import { createApi } from "@reduxjs/toolkit/query/react";
import {
  DocumentTypeWithAnnotations,
  HoldReason,
  InputType,
} from "../interfaces";
import {
  parseReduxQueryError,
  customBaseQuery,
} from "../../common/reduxQuery/helpers";
import { fetchedDocumentTypes } from "./documentTypesSlice";

export const documentTypeApi = createApi({
  reducerPath: "documentTypeApi",
  baseQuery: customBaseQuery(),
  endpoints: (build) => ({
    updateDocumentTypeRequest: build.mutation<
      DocumentTypeWithAnnotations,
      { documentId: string; documentTypeId: string }
    >({
      query: ({ documentId, documentTypeId }) => ({
        url: `/api/v1/documents/${documentId}/document-type/${documentTypeId}`,
        method: "POST",
      }),
    }),
    getHoldReasons: build.query<
      Array<HoldReason>,
      { documentTypeId: string; inputId: string }
    >({
      query: ({ documentTypeId, inputId }) => ({
        url: `/api/v1/document-type/${documentTypeId}/hold-reasons?inputId=${inputId}`,
        method: "GET",
      }),
    }),
    getDocumentTypes: build.query<Array<InputType>, string>({
      query: (inputIds) => ({
        url: `/api/v1/input/document-types?ids=${inputIds}`,
        method: "GET",
      }),
      async onQueryStarted(args, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          dispatch(fetchedDocumentTypes(data));
        } catch (err: unknown) {
          console.error(
            `An error occurred while retrieving the document types: ${parseReduxQueryError(
              err,
            )}`,
          );
        }
      },
    }),
  }),
});

export const {
  useUpdateDocumentTypeRequestMutation,
  useLazyGetDocumentTypesQuery,
  useGetHoldReasonsQuery,
} = documentTypeApi;
